// src/utils/ticketPrintDispatch.js
//
// Whole-branch review, finding 1(b) — how the three order-dispatch paths
// (cashier transactionFlow.dispatchKitchenTickets, waiter
// drawerFlow.buildTrackingRecords, append-mode
// OrderHelpers.updateOrderTrackingRecords) start a kitchen/bar ticket print.
//
// All three run on a path a human is waiting on: the first two under the
// post-payment / submit spinner, the third in front of markOrderEdited (the
// KDS shows the order as un-edited until it lands). A ticket print is a
// network round trip to a backend known to cold-start, followed by a LAN
// POST to a printer that may be off — none of which anyone downstream reads
// a result from. So it is STARTED here and never awaited:
//
//   * the caller returns immediately, whatever the printer does;
//   * several categories overlap instead of queueing behind each other;
//   * a rejection can never surface as an unhandled rejection, or as a
//     failed sale / failed order edit, because it is caught here.
//
// The KDS tracking record is always created — and awaited — by the caller
// BEFORE this is called, so detaching the print never costs the kitchen its
// order. `printCategoryTicket` is contractually non-throwing already; the
// try/catch is belt-and-braces for a synchronous throw it could never
// normally produce.
import { printCategoryTicket } from './PrintingUtils';

export const startTicketPrint = (category, trackingId, tenantConfig) => {
    try {
        const pending = printCategoryTicket(category, trackingId, tenantConfig);
        if (pending && typeof pending.catch === 'function') {
            pending.catch((ticketPrintError) => {
                console.error(`Ticket print failed for category "${category}":`, ticketPrintError);
            });
        }
    } catch (ticketPrintError) {
        console.error(`Ticket print failed for category "${category}":`, ticketPrintError);
    }
};

export default startTicketPrint;
